/**
 * Gauge — DS Chart
 * Semi-cercle SVG 0–100%, couleur selon seuils
 */

import styles from './Gauge.module.css';

interface GaugeProps {
  value: number;  /** 0–100 */
  label?: string;
  size?: number;
  thresholds?: { warn: number; danger: number };
  className?: string;
}

export function Gauge({ value, label, size = 120, thresholds = { warn: 60, danger: 80 }, className = '' }: GaugeProps) {
  const clamped = Math.min(100, Math.max(0, value));
  const r = 44;
  const cx = 60; const cy = 60;
  const circumference = Math.PI * r; // semi-circle
  const strokeDash = (clamped / 100) * circumference;

  let color = 'var(--hrl-action)';
  if (clamped >= thresholds.danger) color = 'var(--hrl-danger)';
  else if (clamped >= thresholds.warn) color = 'var(--hrl-warning)';

  return (
    <div className={`${styles.wrapper} ${className}`} style={{ width: size, height: size * 0.6 + 24 }}>
      <svg width={size} height={size * 0.6} viewBox="0 0 120 66">
        {/* Track */}
        <path
          d={`M ${cx - r},${cy} A ${r},${r} 0 0,1 ${cx + r},${cy}`}
          fill="none" stroke="var(--hrl-gray-100)" strokeWidth="10" strokeLinecap="round"
        />
        {/* Fill */}
        <path
          d={`M ${cx - r},${cy} A ${r},${r} 0 0,1 ${cx + r},${cy}`}
          fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={`${strokeDash} ${circumference}`}
          style={{ transition: 'stroke-dasharray 0.5s ease' }}
        />
        {/* Value */}
        <text x="60" y="52" textAnchor="middle" fontSize="16" fontWeight="700" fill="var(--hrl-gray-900)"
          fontFamily="Inter, system-ui, sans-serif">{clamped}%</text>
      </svg>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
}
